export const ROOM_ATTRIBUTES_KEY = {
  MEETING_INFO: 'meeting_info',
  MUTE_ALL_MIC: 'mute_all_mic',
  MUTE_ALL_CAM: 'mute_all_cam',
  REQUEST_ON_OFF_MIC_USERS: 'request_on_off_mic_users',
  REQUEST_ON_OFF_CAM_USERS: 'request_on_off_cam_users',
  REQUEST_ON_OFF_SHARE_SCREEN: 'request_on_off_share_screen',
  SCREEN: 'screen',
  SCREEN_VERSION: 'screen_version',
  MUTE_ALL_SCREEN: 'mute_all_screen',
  INVITE_OPEN_SCREEN_USERS: 'invite_open_screen_users',
  LOWER_ALL_HAND: 'lower_all_hand',
  REQUEST_OFF_RAISE_HAND_USERS: 'request_off_raise_hand_users',
} as const;

export enum MEETING_MUTE_FLAG {
  NONE = '0',
  HOST_AND_CO_HOST = '1',
  HOST_AND_USERS = '2',
}

export enum MEETING_SHARE_SCREEN_FLAG {
  NONE = '0',
  HOST_AND_CO_HOST = '1',
  HOST_AND_USERS = '2',
}

export const DEVICE_TYPE = {
  MIC: 'MIC',
  CAM: 'CAM',
};

export const MIC_VERSION_DEFAULT = '0';
export const CAM_VERSION_DEFAULT = '0';
export const SHARE_SCREEN_VERSION_DEFAULT = '0';
